import { render } from "./PromoComponent.vue?vue&type=template&id=0a1396f4&scoped=true"
import script from "./PromoComponent.vue?vue&type=script&lang=js"
export * from "./PromoComponent.vue?vue&type=script&lang=js"

import "./PromoComponent.vue?vue&type=style&index=0&id=0a1396f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a1396f4"]])

export default __exports__